import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    itemTransactionReportSearchParams: {
        primaryFilter: {
            fromDate: '',
            toDate: '',
            searchReportingFor: '1',
            searchReportForName: 'Companywise',
            searchBranchIds: '',
            searchBranchNames: [],
            searchInvStoreIds: '',
            searchInvStoreNames: [],
            searchInvItemIds: '',
            searchInvItemNames: [],
            showItemValue: 1,
            showItemValueName: 'No',
            showSerialColumn: false,
        },
    },
    itemTransactionLists: {
        isLoading: false,
        isLoadingMore: false,
        dataLoaded: false,
        data: null,
        totalRecords: 0,
        recordCounts: 0,
        pageNo: 0,
        perPageRecords: 2000,
        itemTransactionError: '',
        itemTransactionMoreError: ''
    },
    loadItemTransactionData: false,
    tableHide: true,
}

const reportItemTransactionSlice = createSlice({
    name: "reportItemTransactionSlice",
    initialState,
    reducers: {
        itemTransactionPrimaryFiltersUpdates: (state, { payload }) => {
            if (payload?.fromDate && payload?.fromDate !== '') {
                state.itemTransactionReportSearchParams.primaryFilter.fromDate = payload.fromDate;
            } else if (payload?.fromDate === '') {
                state.itemTransactionReportSearchParams.primaryFilter.fromDate = '';
            }

            if (payload?.toDate && payload?.toDate !== '') {
                state.itemTransactionReportSearchParams.primaryFilter.toDate = payload.toDate;
            } else if (payload?.toDate === '') {
                state.itemTransactionReportSearchParams.primaryFilter.toDate = '';
            }
            if (payload?.searchReportingFor && payload?.searchReportingFor !== '') {
                state.itemTransactionReportSearchParams.primaryFilter.searchReportingFor = payload.searchReportingFor;
                if (payload.searchReportingFor !== '1') {
                    state.itemTransactionReportSearchParams.showOnlyTrItems = true;
                }
            } else if (payload?.searchReportingFor === '') {
                state.itemTransactionReportSearchParams.primaryFilter.searchReportingFor = '';
            }
            if (payload?.searchReportForName && payload?.searchReportForName !== '') {
                state.itemTransactionReportSearchParams.primaryFilter.searchReportForName = payload.searchReportForName;
            } else if (payload?.searchReportingFor === '') {
                state.itemTransactionReportSearchParams.primaryFilter.searchReportForName = '';
            }

            if (payload?.searchBranchIds && payload?.searchBranchIds !== '') {
                state.itemTransactionReportSearchParams.primaryFilter.searchBranchIds = payload.searchBranchIds;
            } else if (payload?.searchBranchIds === '') {
                state.itemTransactionReportSearchParams.primaryFilter.searchBranchIds = '';
            }
            if (payload?.searchBranchNames && payload?.searchBranchNames?.length > 0) {
                state.itemTransactionReportSearchParams.primaryFilter.searchBranchNames = payload.searchBranchNames;
            } else if (payload?.searchBranchNames?.length === 0) {
                state.itemTransactionReportSearchParams.primaryFilter.searchBranchNames = [];
            }

            if (payload?.searchInvStoreIds && payload?.searchInvStoreIds !== '') {
                state.itemTransactionReportSearchParams.primaryFilter.searchInvStoreIds = payload.searchInvStoreIds;
            } else if (payload?.searchInvStoreIds === '') {
                state.itemTransactionReportSearchParams.primaryFilter.searchInvStoreIds = '';
            }
            if (payload?.searchInvStoreNames && payload?.searchInvStoreNames?.length > 0) {
                state.itemTransactionReportSearchParams.primaryFilter.searchInvStoreNames = payload.searchInvStoreNames;
            } else if (payload?.searchInvStoreNames?.length === 0) {
                state.itemTransactionReportSearchParams.primaryFilter.searchInvStoreNames = [];
            }
            if (payload?.searchInvItemIds && payload?.searchInvItemIds !== '') {
                state.itemTransactionReportSearchParams.primaryFilter.searchInvItemIds = payload.searchInvItemIds;
            } else if (payload?.searchInvItemIds === '') {
                state.itemTransactionReportSearchParams.primaryFilter.searchInvItemIds = '';
            }
            if (payload?.searchInvItemNames && payload?.searchInvItemNames?.length > 0) {
                state.itemTransactionReportSearchParams.primaryFilter.searchInvItemNames = payload.searchInvItemNames;
            } else if (payload?.searchInvItemNames?.length === 0) {
                state.itemTransactionReportSearchParams.primaryFilter.searchInvItemNames = [];
            }
            if (payload?.showItemValue && payload?.showItemValue !== '') {
                state.itemTransactionReportSearchParams.primaryFilter.showItemValue = payload.showItemValue;
            } else if (payload?.showItemValue === '') {
                state.itemTransactionReportSearchParams.primaryFilter.showItemValue = 1;
            }
            if (payload?.showItemValueName && payload?.showItemValueName !== '') {
                state.itemTransactionReportSearchParams.primaryFilter.showItemValueName = payload.showItemValueName;
            } else if (payload?.searchReportingFor === '') {
                state.itemTransactionReportSearchParams.primaryFilter.showItemValueName = '';
            }
        },
        itemTransactionGetData: (state, { payload }) => {
            state.loadItemTransactionData = payload;
        },
        itemTransactionTableLoad: (state, { payload }) => {
            state.tableHide = payload;
        },
        itemTransactionLoadingPending: (state) => {
            state.itemTransactionLists.isLoading = true;
            state.itemTransactionLists.dataLoaded = false;
            state.itemTransactionLists.recordCounts = 0;
            state.itemTransactionLists.totalRecords = 0;
        },
        itemTransactionLoadingSuccess: (state, { payload }) => {
            state.itemTransactionLists.isLoading = false;
            state.itemTransactionLists.data = payload;
            state.itemTransactionLists.itemTransactionError = '';
            state.itemTransactionLists.dataLoaded = true;
            state.loadItemTransactionData = false;
        },
        itemTransactionLoadingFailed: (state, { payload }) => {
            state.itemTransactionLists.isLoading = false;
            state.itemTransactionLists.data = []
            state.itemTransactionLists.itemTransactionError = payload;
            state.itemTransactionLists.dataLoaded = true;
            state.loadItemTransactionData = false;
        },
        itemTransactionLoadMorePending: (state) => {
            state.itemTransactionLists.isLoadingMore = true;
        },
        itemTransactionLoadMoreSuccess: (state, { payload }) => {
            state.itemTransactionLists.isLoadingMore = false;
            state.itemTransactionLists.data = state.itemTransactionLists.data.concat(payload);
            state.itemTransactionLists.jobCardLoadMoreError = '';
        },
        itemTransactionLoadMoreFailed: (state, { payload }) => {
            state.itemTransactionLists.isLoadingMore = false;
            state.itemTransactionLists.jobCardLoadMoreError = payload;
        },
        itemTransactionTotalRecordsUpdate: (state, { payload }) => {
            state.itemTransactionLists.totalRecords = payload.totalRecords || 0;
            state.itemTransactionLists.recordCounts = Number.isInteger(payload.recordCounts) ? (state.itemTransactionLists.recordCounts + payload.recordCounts) : 0;
        },
        itemTransactionPageNoUpdate: (state, { payload }) => {
            state.itemTransactionLists.pageNo = payload;
            state.loadItemTransactionData = true;
        },
        itemTransactionPerPageRecordsUpdate: (state, { payload }) => {
            state.itemTransactionLists.perPageRecords = payload;
            state.itemTransactionLists.pageNo = 0;
            state.loadItemTransactionData = true;
        },
        itemTransactionListReset: (state, { payload }) => {
            state.itemTransactionLists.isLoading = false;
            state.itemTransactionLists.isLoadingMore = false;
            state.itemTransactionLists.dataLoaded = false;
            state.itemTransactionLists.data = null;
            state.itemTransactionLists.totalRecords = 0;
            state.itemTransactionLists.recordCounts = 0;
            state.itemTransactionLists.pageNo = 0;
            state.itemTransactionLists.perPageRecords = 2000;
            state.itemTransactionLists.itemTransactionError = '';
            state.itemTransactionLists.itemTransactionMoreError = '';
        },
        setShowSerialColumn: (state, { payload }) => {
            state.showSerialColumn = payload;
        },
    }
});

const { reducer, actions } = reportItemTransactionSlice;

export const {
    itemTransactionPrimaryFiltersUpdates, itemTransactionGetData,
    itemTransactionLoadingPending, itemTransactionLoadingSuccess, itemTransactionLoadingFailed,
    itemTransactionLoadMorePending, itemTransactionLoadMoreSuccess, itemTransactionLoadMoreFailed,
    itemTransactionTotalRecordsUpdate, itemTransactionPageNoUpdate, itemTransactionPerPageRecordsUpdate,
    itemTransactionListReset, itemTransactionTableLoad, setShowSerialColumn
}
    = actions;

export default reducer;